import axios, { AxiosInstance } from 'axios';

import { Configuration } from 'src/Services/API/generated';
import {
  CreateMoneyTransferDto,
  MoneyTransferDto,
  UpdateMoneyTransferDto,
} from 'src/types/money-transfer.types';

export class MoneyTransferApi {
  private axiosInstance: AxiosInstance;
  private basePath: string;

  constructor(configuration: Configuration) {
    this.basePath = configuration.basePath || '';
    this.axiosInstance = axios.create({
      baseURL: this.basePath,
      ...configuration.baseOptions,
    });
  }

  async create(assetId: string, data: CreateMoneyTransferDto): Promise<MoneyTransferDto> {
    const response = await this.axiosInstance.post<MoneyTransferDto>(
      `/assets/${assetId}/money-transfers`,
      data
    );
    return response.data;
  }

  async findAll(assetId: string, year?: number): Promise<MoneyTransferDto[]> {
    const response = await this.axiosInstance.get<MoneyTransferDto[]>(
      `/assets/${assetId}/money-transfers`,
      { params: year !== undefined ? { year } : undefined }
    );
    return response.data;
  }

  async update(
    assetId: string,
    id: string,
    data: UpdateMoneyTransferDto
  ): Promise<MoneyTransferDto> {
    const response = await this.axiosInstance.patch<MoneyTransferDto>(
      `/assets/${assetId}/money-transfers/${id}`,
      data
    );
    return response.data;
  }

  async delete(assetId: string, id: string): Promise<void> {
    await this.axiosInstance.delete(`/assets/${assetId}/money-transfers/${id}`);
  }
}
